import { useEffect, useState } from "react"
import { Bar } from "react-chartjs-2"
import { Row, Col } from "react-bootstrap"
import HeaderSelector from "./HeaderSelector"
import DetailTable from "./DetailTable"
import OrderFocus from "./OrderFocus"
import SummaryTable from "./SummaryTable"
import {
  getData,
  labels,
  borderColor,
  defaultGraphData,
  backgroundColor,
  defaultSelectors,
  defaultSelected,
  defaultHeaderInfo,
  fetchSelectors,
} from "./helpers"
import "./styles.css"

const Aging = () => {
  const [graphData, setGraphData] = useState(defaultGraphData)
  const [summaryTable, setSummaryTable] = useState([])
  const [detailTable, setDetailTable] = useState([])
  const [infoDisplay, setInfoDisplay] = useState(null)
  const [selectors, setSelectors] = useState(defaultSelectors)
  const [selected, setSelected] = useState(defaultSelected)
  const [headerInfo, setHeaderInfo] = useState(defaultHeaderInfo)
  const [csvDownloadTracker, setCsvDownloadTracker] = useState(false)
  const [hasAccess, setHasAccess] = useState(null)

  useEffect(() => {
    fetchSelectors(setSelectors)
  }, [])

  useEffect(() => {
    getData(
      setGraphData,
      setSummaryTable,
      setDetailTable,
      setHeaderInfo,
      selected,
      setHasAccess
    )
    setInfoDisplay(null)
    setCsvDownloadTracker(false)
  }, [selected])

  const values = graphData.map((item) => item.value)
  const sumAmounts = graphData.map((item) => item.sum_amount)

  const barData = {
    labels: labels,
    datasets: [
      {
        data: values,
        backgroundColor: backgroundColor,
        borderColor: borderColor,
        borderWidth: 1,
      },
    ],
  }

  const options = {
    scales: {
      y: {
        beginAtZero: true,
      },
    },
    plugins: {
      tooltip: {
        callbacks: {
          label: function (context) {
            const value = context.parsed.y
            const formattedAmount = Number(
              sumAmounts[context.dataIndex]
            ).toLocaleString()
            return `${value} Orders (Total Amount: $${formattedAmount})`
          },
        },
        displayColors: false,
        mode: "index",
        intersect: false,
      },
      legend: {
        display: true,
        position: "top",
      },
    },
  }
  if (hasAccess === null) {
    return <div>Loading ... </div>
  }
  if (hasAccess === false) {
    return <div>You don't have access to the Aging Report</div>
  }
  return (
    <div className='aging-container'>
      <HeaderSelector
        selectors={selectors}
        selected={selected}
        setSelected={setSelected}
        headerInfo={headerInfo}
        setCsvDownloadTracker={setCsvDownloadTracker}
      />
      <Row className='aging-container-first-row'>
        <Col xs={12} md={4} className='aging-bar-container'>
          <Bar data={barData} options={options} />
        </Col>
        <Col xs={12} md={8}>
          <OrderFocus data={infoDisplay} />
        </Col>
      </Row>
      <Row className='aging-container-second-row'>
        {selected.customer.length === 0? (
          <SummaryTable
            data={summaryTable}
            setSelected={setSelected}
            setSelectors={setSelectors}
            csvDownloadTracker={csvDownloadTracker}
            setCsvDownloadTracker={setCsvDownloadTracker}
          />
        ) : (
          <DetailTable
            data={detailTable}
            setInfoDisplay={setInfoDisplay}
            csvDownloadTracker={csvDownloadTracker}
            setCsvDownloadTracker={setCsvDownloadTracker}
            selected={selected}
          />
        )}
      </Row>
    </div>
  )
}

export default Aging
